import { mapEnumToOptions } from '@abp/ng.core';

export enum CouponDiscountType {
  Percentage = 0,
  Fixed = 1,
}

export const couponDiscountTypeOptions = mapEnumToOptions(CouponDiscountType);
